import { Link } from "react-router-dom";
import React from "react";

export const home = { content: <Link to={`/home/Dashboard`}>Inicio</Link> };
export const configuration = {
  content: <Link to={`/home/Configuration`}>Configuración</Link>,
};
export const trackDocument = {
  content: <Link to={`/home/TrackingDocuments`}>Seguimiento documentos electrónicos</Link>,
};


export const sectionsConfiguration = [home, configuration];

export const sectionHome = [home];

export const sectionsInvoice = [home, trackDocument];
